import React, { forwardRef } from 'react';
import { cn } from './cn';

/** Nonmodal detail alongside a conversation; covers its host on narrow screens.
 * Closed content stays mounted so an editor retains its draft. */
const SideWorkspace = forwardRef(function SideWorkspace({ open, width = 620, children, className, ...props }, ref) {
  return <aside {...props} ref={ref} hidden={!open} aria-hidden={!open} inert={!open ? '' : undefined} style={{ '--workspace-width': `${width}px` }} className={cn('absolute inset-0 z-40 min-h-0 min-w-0 flex-col overflow-hidden border-l border-bun-line bg-bun-surface text-bun-text lg:relative lg:inset-auto lg:w-[var(--workspace-width)] lg:max-w-[calc(100%_-_360px)] lg:shrink-0', open ? 'flex' : 'hidden', className)}>{children}</aside>;
});

function Header({ icon, label, title, meta, actions, children }) {
  return <header className="flex shrink-0 flex-wrap items-center gap-3 border-b border-bun-line px-[18px] py-3">
    {title && <div className="flex min-w-0 flex-[1_1_240px] items-center gap-3 text-bun-text">
      {icon && <span aria-hidden="true" className="flex h-9 w-9 shrink-0 items-center justify-center [&_svg]:h-6 [&_svg]:w-6">{icon}</span>}
      <div className="min-w-0 flex-1 space-y-1">
        {label && <div className="font-instrument text-[12px] leading-4">{label}</div>}
        <h2 title={typeof title === 'string' ? title : undefined} className="m-0 font-instrument text-[14px] font-semibold leading-5 tracking-normal [overflow-wrap:anywhere]">{title}</h2>
        {meta && <div className="font-instrument text-[12px] leading-4">{meta}</div>}
      </div>
    </div>}
    {children}
    {actions && <div className="ml-auto flex max-w-full flex-wrap items-center justify-end gap-2">{actions}</div>}
  </header>;
}

function ResizeHandle({ value, min, max, onPointerDown, onKeyDown, onDoubleClick, label }) {
  return <div role="separator" aria-label={label} aria-orientation="vertical" aria-valuemin={min} aria-valuemax={max} aria-valuenow={value} tabIndex={0} onPointerDown={onPointerDown} onKeyDown={onKeyDown} onDoubleClick={onDoubleClick} className="absolute inset-y-0 left-0 z-50 hidden w-[6px] cursor-col-resize touch-none hover:bg-bun-ring focus-visible:bg-bun-ring focus-visible:outline focus-visible:outline-2 focus-visible:outline-bun-blue lg:block" />;
}
SideWorkspace.Header = Header;
SideWorkspace.ResizeHandle = ResizeHandle;
export default SideWorkspace;
